"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUserFeedbackRequest = void 0;
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const isSurveyQuestionID = (id) => {
    return Object.values(notification_center_models_1.SurveyQuestionID).includes(id);
};
const isSurveyResponseID = (id) => {
    return Object.values(notification_center_models_1.SurveyResponseID).includes(id);
};
const toUserFeedbackRequest = (questionResponse) => {
    if (!isSurveyQuestionID(questionResponse.id)) {
        throw new Error('Invalid SurveyQuestionID');
    }
    return {
        answeredQuestions: [
            {
                id: questionResponse.id,
                responses: questionResponse.responses.map((response) => {
                    if (!isSurveyResponseID(response.id)) {
                        throw new Error('Invalid SurveyResponseID');
                    }
                    return {
                        id: response.id,
                        comment: response.comment,
                    };
                }),
            },
        ],
    };
};
exports.toUserFeedbackRequest = toUserFeedbackRequest;
//# sourceMappingURL=SurveyQuestionResponse.js.map